import { MAIL_NOTIFICATION_STATUS_EMAIL_TYPE } from "@/static/mailNotificationStatusEmailTypes";
import { DocumentToPrint } from "@/models/api/mail/DocumentToPrint";
import { EMAIL_ADDRESS_TYPE } from "@/static/emailAddressTypes";
import { BookingFile } from "./Document";

export class EmailAddressType {
  TypeEmailAddress!: EMAIL_ADDRESS_TYPE;
  EmailAddress!: string;
}

export class SendMail {
  EmailAddressesToSend!: Array<EmailAddressType>;
  Documents!: Array<DocumentToPrint>;
  EmailType!: MAIL_NOTIFICATION_STATUS_EMAIL_TYPE;
  Content!: string;
  Subject!: string;
  AllInOneFile!: boolean;
  MailConfigurationId!: number;
  TemporaryFileIds!: Array<number>;
  BookingFiles!: Array<BookingFile>;
}
